import { ICartItem, IProductLineItem } from "../../container/cart/ICart";
import { ProductTypes } from "../../services/helper/cart/constants";

export interface ICartObjByKey<T> {
    [key: string]: T
}

export const getCartItemsByProductType = (cartItems: ICartItem[] = []): ICartObjByKey<ICartItem[] | IProductLineItem[]> => {
    const cartObj: ICartObjByKey<ICartItem[] | IProductLineItem[]> = {};
    for (const item of cartItems) {
        if (cartObj[item.type]) {
            cartObj[item.type].push(item as any);
        } else {
            cartObj[item.type] = [item];
        }

        // Handling savingPlans Gracefully
        for (let childItem of (item?.childrenLineItems || [])) {
            if (childItem.key === ProductTypes.SAVINGS_PLAN) {
                childItem = {
                    ...childItem,
                    parentLineItemId: item.id
                }
                if (cartObj[childItem.key]) {
                    cartObj[childItem.key].push(childItem as any)
                } else {
                    cartObj[childItem.key] = [childItem] as IProductLineItem[]
                }
            }
        }
    }
    return cartObj;
}
